import { render, staticRenderFns } from "./FundsTransfer.vue?vue&type=template&id=4a0216a0&scoped=true&"
import script from "./FundsTransfer.vue?vue&type=script&lang=js&"
export * from "./FundsTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0216a0",
  null
  
)

export default component.exports